{
  "name": "crm-umans",
  "version": "2.0.11",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:debug": "playwright test --debug",
    "e2e:codegen": "playwright codegen https://localhost:4200",
    "rehearse:build": "ng build --configuration rehearsal",
    "rehearse": "node e2e/cookie-rehearsal.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.5",
    "@angular/cdk": "^21.1.5",
    "@angular/common": "^21.1.5",
    "@angular/compiler": "^21.1.5",
    "@angular/core": "^21.1.5",
    "@angular/forms": "^21.1.5",
    "@angular/google-maps": "^21.1.5",
    "@angular/material": "^21.1.5",
    "@angular/material-luxon-adapter": "^21.1.5",
    "@angular/platform-browser": "^21.1.5",
    "@angular/platform-browser-dynamic": "^21.1.5",
    "@angular/router": "^21.1.5",
    "@kolkov/angular-editor": "^3.0.5",
    "@livechat/widget-angular": "^1.3.4",
    "@material/material-color-utilities": "^0.4.0",
    "@ngx-formly/core": "^7.1.0",
    "@ngx-formly/material": "^7.1.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@paypal/paypal-js": "^8.2.0",
    "@rg/shared-ng": "file:../shared-ng/rg-shared-ng-0.0.0.tgz",
    "@uiowa/digit-only": "^3.2.1",
    "angularx-qrcode": "^21.0.0",
    "aws-amplify": "^6.18.0",
    "google-libphonenumber": "^3.2.41",
    "highcharts": "^11.4.8",
    "highcharts-angular": "^3.1.2",
    "intl-tel-input": "^21.2.8",
    "luxon": "^3.6.1",
    "ng-recaptcha-2": "^21.0.0",
    "ngx-image-cropper": "^8.1.1",
    "ngx-quill": "^30.0.0",
    "ngx-scanner-qrcode": "^1.8.1",
    "qrcode": "^1.5.4",
    "quill": "2.0.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1",
    "vanilla-jsoneditor": "^0.17.10",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.0/xlsx-0.20.0.tgz",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.1.5",
    "@angular/cli": "~21.1.5",
    "@angular/compiler-cli": "^21.1.5",
    "@ngx-formly/schematics": "^6.3.12",
    "@playwright/test": "^1.52.0",
    "@types/google-libphonenumber": "^7.4.30",
    "@types/googlemaps": "^3.43.3",
    "@types/intl-tel-input": "^18.1.4",
    "@types/luxon": "^3.6.2",
    "@types/qrcode": "^1.5.5",
    "autoprefixer": "^10.4.21",
    "jsdom": "^29.1.1",
    "postcss": "^8.5.6",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.9.3",
    "vitest": "^4.1.7",
    "webpack-bundle-analyzer": "^4.10.2"
  }
}
